/*!
 * Ocean Curls — global enhancements
 *
 * Adds gentle scroll-reveal animations to any element tagged with
 * `.oc-reveal`, `.oc-reveal-left`, or `.oc-reveal-right`.
 * Self-injects the required CSS — no separate stylesheet needed.
 * Respects prefers-reduced-motion.
 * Re-binds after Customizer section reloads via `shopify:section:load`.
 */
(function () {
  // ── Inject reveal styles once ──────────────────────────────────────
  if (!document.getElementById('oc-reveal-styles')) {
    var style = document.createElement('style');
    style.id = 'oc-reveal-styles';
    style.textContent = [
      '.oc-reveal, .oc-reveal-left, .oc-reveal-right {',
      '  opacity: 0;',
      '  transition: opacity .7s ease, transform .7s ease;',
      '  will-change: opacity, transform;',
      '}',
      '.oc-reveal { transform: translateY(24px); }',
      '.oc-reveal-left { transform: translateX(-30px); }',
      '.oc-reveal-right { transform: translateX(30px); }',
      '.oc-reveal.is-visible,',
      '.oc-reveal-left.is-visible,',
      '.oc-reveal-right.is-visible {',
      '  opacity: 1;',
      '  transform: none;',
      '}',
      '@media (prefers-reduced-motion: reduce) {',
      '  .oc-reveal, .oc-reveal-left, .oc-reveal-right {',
      '    opacity: 1 !important;',
      '    transform: none !important;',
      '    transition: none !important;',
      '  }',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  // ── Observer ────────────────────────────────────────────────────────
  function observeReveals() {
    var els = document.querySelectorAll(
      '.oc-reveal:not(.is-visible), .oc-reveal-left:not(.is-visible), .oc-reveal-right:not(.is-visible)'
    );
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      // Graceful fallback — just show everything.
      Array.prototype.forEach.call(els, function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.07, rootMargin: '0px 0px -40px 0px' });

    Array.prototype.forEach.call(els, function (el) {
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeReveals);
  } else {
    observeReveals();
  }

  // Re-scan when a Customizer section is added / re-rendered.
  document.addEventListener('shopify:section:load', observeReveals);
})();